module.exports = __webpack_public_path__ + "img/gn.1e2c3aa8.svg";